<template>
  <div class="overdue-interest">
    <SiruiSearch
      ref="overdueInterestFormRef"
      :query="overdueForm"
      :columns="formColumn"
      :isQueryPanel="false"
      :rules="formRule"
      labelWidth="160px"
      @changeMethod="changeMethod"
    ></SiruiSearch>
  </div>
</template>

<script>
  import { baseColumnList, baseFormRule } from './index.js';
  import { formatDate } from '@/utils';

  export default {
    name: 'OverdueInterest',
    data() {
      return {
        overdueForm: {
          isOverdueInterest: false,
          receivableStartDate: null,
          overduePaymentInterest: '',
          receivableDate: null,
          receivableRule: '',
          defaultInterestRate: '',
        },
      };
    },
    props: {
      orderInterest: {
        type: Object,
        default: () => {},
      },
      contractStatus: {
        type: String,
        default: () => '',
      },
      isDisableOverdueInterest: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      formColumn() {
        return baseColumnList(this, this.contractStatus);
      },
      formRule() {
        return baseFormRule(this);
      },
    },
    methods: {
      changeMethod(val) {
        console.log(val, '点击');
      },
      validate() {
        return new Promise((resolve, reject) => {
          this.$refs.overdueInterestFormRef.validate((valid, formData) => {
            if (valid) {
              resolve({
                ...formData,
                receivableStartDate: formData.receivableDate
                  ? formatDate(formData.receivableStartDate)
                  : null,
                receivableDate: formData.receivableDate
                  ? formatDate(formData.receivableDate)
                  : null,
              });
            } else {
              reject('请补充参数');
              this.$message.error('请填写资料');
            }
          });
        });
      },
    },
    watch: {
      orderInterest: {
        handler(val) {
          if (Object.keys(val).length) {
            console.log('数据变动', val);
            // this.overdueForm = val;
            for (const key in val) {
              this.overdueForm[key] = typeof val[key] === 'number' ? val[key] + '' : val[key];
            }
          }
        },
        deep: true,
        immediate: true,
      },
      'overdueForm.isOverdueInterest': {
        handler(val) {
          console.log(val, '监听');
          if (!val) {
            this.overdueForm = {
              isOverdueInterest: false,
              receivableStartDate: null,
              overduePaymentInterest: '',
              receivableDate: null,
              receivableRule: '',
              defaultInterestRate: '',
            };
          }
        },
      },
    },
  };
</script>

<style lang="scss" scoped></style>
